<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<el-tabs v-model="tabIndex" @tab-click="getList">
			
			<el-tab-pane :key="tabI" v-for="(tab, tabI) in tabbars">
				<span slot="label" class="d-flex">
					<div style="">{{tab.name}}</div>
					<div v-if="tab.num != 0" style="background: #ffa303;width: 24px;height: 18px;border-radius: 10px;margin-top: 6px;justify-content: center;align-items: center;" class="d-flex">
						<div style="font-size: 10px;color: #fff;font-weight: 800;">{{tab.num}}</div>
					</div>
				</span>
			</el-tab-pane>
		</el-tabs>
		<button-search ref="buttonSearch" placeholder="要搜索的商品名称" @search="searchEvent" class="pb-2">
			<!-- 左边 -->
			<template #left>
				<el-button type="primary" size="mini" icon="el-icon-plus" @click="navigate('ckgl_ckcl_pdd_create')">下单</el-button>
				<el-button type="danger" size="mini" icon="el-icon-delete">删除</el-button>
				<el-dropdown class="ml-2 mr-2">
					<el-button type="success" icon="el-icon-s-promotion" size="mini">审核</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item><div style="color: #7c7eff;font-size: 12px;" @click="states(1, multipleSelection)">同意</div></el-dropdown-item>
						<el-dropdown-item><div style="color: #d00003;font-size: 12px;" @click="states(2, multipleSelection)">拒绝</div></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</template>
		
			<!-- 高级搜索表单 -->
			<template #form>
				<el-form inline ref="form" :model="form" label-width="80px">
					<el-form-item label="商品名称" class="mb-0"><el-input v-model="form.title" placeholder="商品名称" size="mini"></el-input></el-form-item>
					<el-form-item label="商品分类" class="mb-0">
						<el-select v-model="form.category_id" placeholder="请选择商品分类" size="mini">
							<el-option v-for="item in cateOptions" :key="item.id" :label="item | tree" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>
			</template>
		</button-search>
		
		

		<!-- 商品列表 -->
		<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" size="mini" key="table1" :max-height="maxHeight">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column align="center" prop="id" width="50" label="编号" fixed="left"></el-table-column>
			<el-table-column prop="ddh" width="120" label="订单号"></el-table-column>
			<el-table-column label="审核状态">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.shzt == 0">待审核</el-button>
					<el-button type="success" size="mini" plain v-else>已审核</el-button>
				</template>
			</el-table-column>
			<el-table-column label="盘点状态">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.pdzt == 0">未处理</el-button>
					<el-button type="success" size="mini" plain v-else>已处理</el-button>
				</template>
			</el-table-column>
			<el-table-column label="盘点仓库">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{scope.row.pdck.name}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="业务员">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{scope.row.ywy.name}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" label="下单时间"></el-table-column>
			<!-- 操作 -->
			<el-table-column align="center" label="操作" fixed="right" width="300">
				<template slot-scope="scope">
					<div v-if="tab != 'delete'">
						<el-button type="primary" size="mini" @click="navigate('ckgl_ckcl_pdd_create',scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
						<el-button type="warning" size="mini" @click="ckqrone(scope.row)">盘点确认</el-button>
					</div>
					<div v-else>暂无操作</div>
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			preUrl: 'kcpdd', // api
			maxHeight: 0,
			activeNames: ['1'],
			tabIndex: 0,
			tableDatac: [],
			tabbars: [
				{ name: '全部订单', key: 'all' ,num:0},
				{ name: '待审核', key: 'dsh' ,num:0},
				{ name: '已审核', key: 'ysh' ,num:0},
				{ name: '不通过', key: 'btg' ,num:0},
				{ name: '待盘点', key: 'dpd' ,num:0},
				{ name: '已盘点', key: 'ypd' ,num:0}
			],
			form: {
				id: 789,
				name: '恒大集团',
				phone: '1256545645',
				zjphone: '020-656846',
				lxr: '打工仔A',
				email: '45848@qq.com',
				city: '广东省-广州市-天河区',
				xxdz: '广东省广州市天河区体育西地铁出口左转60000米',
				desc: '有钱任性',
				state: 1,
				xssl: 99,
				xstime: '2022-08-22 19:55:21',
				time: '2022-08-22 19:55:21',
				gz: '打工仔F',
				zr: '打工仔O',
				user: '打工仔A',
				gxsw: '打工仔V'
			},
			tableData: [],
			cateOptions: [],
			createModel: false,
			value: '更多',
			direction: 'rtl',
			options: [
				{
					value: '选项1',
					label: '黄金糕'
				},
				{
					value: '选项2',
					label: '双皮奶'
				},
				{
					value: '选项3',
					label: '蚵仔煎'
				},
				{
					value: '选项4',
					label: '龙须面'
				},
				{
					value: '选项5',
					label: '北京烤鸭'
				}
			],
			values: '',
			radio4: '个人',
			num:99,
		};
	},
	filters: {
		tree(item) {
			if (item.level == 0) {
				return item.name;
			}
			let str = '';
			for (let i = 0; i < item.level; i++) {
				str += i == 0 ? '|--' : '--';
			}
			return str + ' ' + item.name;
		}
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user,
			navBar: state => state.menu.navBar
		}),
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	// 生命周期，调用__getData生成的数据
	created() {},
	// 生命周期监听页面
	mounted(){
	 	this.$nextTick(()=>{
	 	    this.maxHeight = window.innerHeight - 274;//300是页面中除了表格外其他组件的高度
	 	   })
	},
	methods: {
		states(e, f) {
			if (f.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else if (f[0].shzt == 1) {
				return this.$message({
					type: 'error',
					message: '订单已完成审核'
				});
			}else{
				let x = f.map(i => {
					return i.id;
				});
				let i = {
					shzt: e,
					ids: x,
					fsr:this.user.id
				};
				this.axios.post('/admin/kcpdd/update_status', i,{
					token: true
				}).then(res => {
					this.getList()
				})
			}
			
		},
		gotos(e) {
			this.$router.push({
				name: e
			});
		},
		// 鼠标单击的事件
		navigate(name, e) {
			// 初始化表单
			if (!e) {
				var data = {
					ddh: '自动生成',
					desc: '',
					ywy: '',
					bm: '',
					pdck: '',
					cjr: this.user.id,
					id:0
				};
			} else {
				var data = {
					ddh: e.ddh,
					desc: e.desc,
					ywy: e.ywy.id,
					bm: e.bm.id,
					pdck: e.pdck.id,
					cjr: e.cjr.id,
					id:e.id,
					pdzt:e.pdzt
				};
				var dbcps = e.dbcps
			}
			console.log(data,dbcps)
			this.$router.push({
				name,
				params: { data,dbcps }
			});
		},
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.tableData = e.list;
			this.cateOptions = e.cates;
			this.tabbars[1].num = e.dsh
			this.tabbars[4].num = e.dpd
		},
		// 上下架
		changeStatus(item) {
			item.status = item.status === 1 ? 0 : 1;
		},
		// 清空筛选条件
		clearSearch() {
			this.form = {
				title: '',
				category_id: ''
			};
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.form.title = e;
			}
			// 高级搜索
			this.getList();
		},
		// 删除商品/恢复商品
		doEvent(key) {
			if (this.ids.length === 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的商品'
				});
			}
			this.showLoading();
			this.axios
				.post(
					'/admin/goods/' + key,
					{
						//删除商品/恢复商品api（restore、destroy区别 删除/回复）
						ids: this.ids
					},
					{
						token: true
					}
				)
				.then(res => {
					this.$message({
						type: 'success',
						message: '操作成功'
					});
					this.getList();
					this.hideLoading();
				})
				.catch(err => {
					this.hideLoading();
				});
		},
		// 上下架
		changeStatus(status) {
			if (this.ids.length === 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的商品'
				});
			}
			this.showLoading();
			this.axios
				.post(
					'/admin/goods/changestatus',
					{
						//商品上下架api
						ids: this.ids,
						status
					},
					{
						token: true
					}
				)
				.then(res => {
					this.$message({
						type: 'success',
						message: '操作成功'
					});
					this.getList();
					this.hideLoading();
				})
				.catch(err => {
					this.hideLoading();
				});
		},
		// 审核商品 ischeck审核 1同意 2拒绝
		checkGoods(item, ischeck) {
			this.layout.showLoading();
			this.axios
				.post(
					'/admin/goods/' + item.id + '/check',
					{
						//审核商品 api
						ischeck
					},
					{
						token: true
					}
				)
				.then(res => {
					this.getList();
					this.$message({
						type: 'success',
						message: '操作成功'
					});
					this.layout.hideLoading();
				})
				.catch(err => {
					this.layout.hideLoading();
				});
		},
		openModel(e = false) {
			this.tableData[e.row.id - 1] = {
				id: e.row.id,
				create_time: '2022-08-19 14:40:20',
				name: e.row.name,
				class: e.row.class,
				state: 1,
				user: '你好啊'
			};
			// 打开dialog
			this.createModel = true;
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		ckqrone(e){
			let i = []
			i.push(e)
			this.rkqr(i)
		},
		rkqr(e){
			if(e[0].pdzt == 1){
				return this.$message({
					type: 'error',
					message: '订单已完成盘点'
				});
			}else {
				if(e[0].shzt == 0){
					return this.$message({
						type: 'error',
						message: '订单未审核'
					});
				}else if(e[0].shzt == 2){
					return this.$message({
						type: 'error',
						message: '订单审核不通过'
					});
				}else{
					let f = {
						id:e[0].id,
					}
					this.axios.post('/admin/kcpdd/pdzt', f,{
						token: true
					}).then(res => {
						this.getList()
						return this.$message({
							type: 'success',
							message: '盘点成功'
						});
						
					})
				}
			}
		},
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
</style>
